import { render, staticRenderFns } from "./list-2.vue?vue&type=template&id=495c7268&scoped=true"
import script from "./list-2.vue?vue&type=script&lang=js"
export * from "./list-2.vue?vue&type=script&lang=js"
import style0 from "./list-2.vue?vue&type=style&index=0&id=495c7268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c7268",
  null
  
)

export default component.exports